import { createConfig, http } from 'wagmi';
import { polygon } from 'wagmi/chains';

const polygonRpcUrl = 'https://wiser-practical-dawn.matic.quiknode.pro/6e2653f710046dd0717dc94c42ff0f2d12ae5ec9';

export const wagmiConfig = createConfig({
  chains: [polygon],
  transports: {
    [polygon.id]: http(polygonRpcUrl),
  },
});
